export default "__VITE_ASSET__db049679__"